export const USERS_INDEX__SET_ALL = 'USERS_INDEX__SET_ALL';
export const USERS_INDEX__ADD_RESOURCE = 'USERS_INDEX__ADD_RESOURCE';
export const USERS_INDEX__UPDATE_RESOURCE = 'USERS_INDEX__UPDATE_RESOURCE';
export const USERS_INDEX__REMOVE_RESOURCE = 'USERS_INDEX__REMOVE_RESOURCE';
export const USERS_INDEX__CLEAR_ALL = 'USERS_INDEX__CLEAR_ALL';
